<template>
  <div v-if="marker" class="card modal-card-border">
    <div class="card-content">
      <div class="columns is-marginless">
        <div class="column is-9">
          <h1 class="is-5">
            <span class="subtitle"> Emplacement </span>
            <span class="title is-5">{{face.facCode}}</span>
          </h1>
          <h2 class="subtitle is-6"> Réseau : {{face.libelleReseau}} </h2>
        </div>
      </div>
      <div class="columns is-marginless">
        <section class="colums is-6 columns is-marginless is-align-items-center">
          <a
           v-if="marker.faces.length > 1"
            @click="precedent()"
            :class="{disabled: !peutAllerPrecedent() }"
            class="column is-narrow mdi mdi-chevron-left mdi-24px">
          </a>
          <div class="column">
            <img class="is-width-350px is-min-width-350px" :src="urlPhoto">
          </div>
          <a
           v-if="marker.faces.length > 1"
            @click="suivant()"
            :class="{disabled: !peutAllerSuivant() }"
            class="column is-narrow mdi mdi-chevron-right mdi-24px">
          </a>
        </section>
        <section class="column">
          <h1 class="subtitle is-6">Informations</h1>
          <div class="columns">
            <div class="column is-6">
              <p class="is-size-14px">Adresse commerciale</p>
              <p>
                <span> {{face.adresse1}} </span>
                <span v-if="face.adresse2"> {{face.adresse2}} </span>
                <span v-if="face.adresse3"> {{face.adresse3}} </span>
                <br>
                <strong> {{face.codePostal}} {{face.ville}} </strong>
              </p>
              <br>
              <p class="is-size-14px">Format</p>
              <span>{{face.format}}</span>
            </div>
            <div class="column is-6">
              <p class="is-size-14px">Matériel</p>
              <p> {{face.materiel}} </p>
              <br>
              <p class="is-size-14px">Eclairé</p>
              <p> {{face.eclaire}} </p>
              <br>
              <p class="is-size-14px">Azimut</p>
              <p> {{face.azimut}} </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'info-window-map',
  props: ['marker'],
  computed: {
    face() {
      if (!this.marker) return null;
      return this.marker.faces[this.marker.indexFaceCourant];
    },
    urlPhoto() {
      if (this.face.urlPhoto) return this.face.urlPhoto;
      return this.face.img;
    },
  },
  methods: {
    cloture() {
      this.$emit('closeInfoWindow');
    },
    precedent() {
      if (this.peutAllerPrecedent()) {
        this.marker.indexFaceCourant = this.marker.indexFaceCourant - 1;
      }
    },
    suivant() {
      if (this.peutAllerSuivant()) {
        this.marker.indexFaceCourant = this.marker.indexFaceCourant + 1;
      }
    },
    peutAllerPrecedent() {
      return this.marker.indexFaceCourant !== 0;
    },
    peutAllerSuivant() {
      return this.marker.indexFaceCourant + 1 < this.marker.faces.length;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/creationOpportunite/cartographie/infoWindowMapFaces.vue